import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSingleBySlug } from 'redux/actions';
import { isFetchingSingle } from 'redux/reducers';
import { isAuthed, getToken } from 'redux/query';

export const useWithSingle = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();

  const authed = useSelector(isAuthed);
  const token = useSelector(getToken);
  const isFetching = useSelector((state) => authed && isFetchingSingle(state));

  useEffect(() => {
    if (authed) {
      dispatch(getSingleBySlug(slug));
    }
  }, [slug, authed]);

  useEffect(() => {
    if (authed && token) {
      dispatch(getSingleBySlug(slug));
    }
  }, [token]);

  return {
    isFetching,
    isAuthed: authed,
    token
  };
};
